import { useSpecies } from '@agria/paws/src/hooks/useSpecies';
import BaseHero, { HeroProps } from '@agria/theme/src/components/hero/Hero';
import React, { useContext } from 'react';
import { QuoteContext } from '../context/QuoteContext';
import { useHeroImages } from '../hooks/useHeroImages';
import { AllowedSpecies } from '../types/global';

interface QabHeroProps extends Omit<HeroProps, 'image'> {
  override?: 'default' | 'dog' | 'cat' | 'equine' | 'rabbit' | string;
}

export const Hero = ({ override, ...props }: QabHeroProps) => {
  const species = useSpecies();
  const { activeSpecies } = useContext(QuoteContext);
  // Get images
  const images = useHeroImages();
  let imageFile = 'default';

  const activeSpeciesName = species
    .find((s) => s.id === activeSpecies)
    ?.name?.toLowerCase() as AllowedSpecies;
  if (override) {
    imageFile = override;
  } else if (activeSpeciesName) {
    imageFile = activeSpeciesName;
  }

  const image = images[imageFile];

  return <BaseHero image={image} {...props} />;
};
